import { UrlUtil } from "@wind/util/client";

/**
 * Generates links for authentication related pages
 *
 * @author @mxs2019
 */
class AuthLinkGenerator {
  static makeLoginRedirectPath(currentRequest: Request) {
    const searchParams = AuthLinkGenerator.makeReturnToSearchParams(currentRequest);

    return UrlUtil.makePath("/auth", searchParams);
  }

  static makeSignupPath(request: Request) {    
    const searchParams = AuthLinkGenerator.makeReturnToSearchParams(request);

    return UrlUtil.makePath("/s/signup", searchParams);
  }

  private static makeReturnToSearchParams(request: Request) {
    const url = new URL(request.url);
    const pathname = url.pathname;
    const searchParams = url.searchParams;

    /**
     * Ensure the path is internal by validating it starts with a single '/'
     * and doesn't contain any '..' path traversal
     */
    const isValidInternalPath =
      pathname.startsWith("/") && !pathname.startsWith("//") && !pathname.includes("..");

    const returnTo = isValidInternalPath ? UrlUtil.makePath(pathname,searchParams) : null;

    const returnToSearchParams = new URLSearchParams();
    if (returnTo) {
      returnToSearchParams.set("returnTo", returnTo);
    }
    return returnToSearchParams;
  }
}

export default AuthLinkGenerator;
